import { postRequest } from 'config/Axios/baseConfig';
import { ReleasingPriorityListResponse } from 'screens/ReleasingPriorityList/ReleasingPriorityListTypes';

export const getReleasingPriorityListService = {
  getReleasingPriorityList: (): Promise<ReleasingPriorityListResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await postRequest<ReleasingPriorityListResponse>(
          'pps/get-releasing-priority-list/',
          { date: null }
        );
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
